import { render, staticRenderFns } from "./paymentRuleList.vue?vue&type=template&id=c1ad2f02&scoped=true&"
import script from "./paymentRuleList.vue?vue&type=script&lang=js&"
export * from "./paymentRuleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ad2f02",
  null
  
)

export default component.exports